<template>
  <Block
    type="pageContainer"
    id="accountSetting"
    :class="[$platformClass, customExeCenterStyle]"
  >
    <Header v-if="!$isOmni" :showLogout="true"></Header>
    <common-header
      v-if="$isOmni && isSDK"
      is-passport
      :show-back="!isSDK"
      :show-lang="!isSDK"
      :title="accountLanguages.accountSetting"
    ></common-header>
    <List
      type="passportFunctionList"
      class="passport-functions"
      :class="$platformClass"
    >
      <ListItem
        type="accountSettingItem"
        rightSpan="0"
        :beforeIconType="$isOmni ? 'userAccount' : undefined"
        :afterIconType="$isOmni ? 'selectHiliAccount' : 'selectHili'"
        class="passport-function account-setting-function j-upgrade-btn"
        :class="$platformClass"
        v-if="showUpgrade"
        v-touchActive
      >
        <router-link to="/accountUpgrade" class="link-wrapper">
          <Block
            tagName="p"
            :type="$isOmni ? 'accountFunctionListItem' : 'funtionListItem'"
            class="function-name"
          >
            {{ languages.upgrade }}
          </Block>
        </router-link>
      </ListItem>
      <ListItem
        type="accountSettingItem"
        rightSpan="0"
        :beforeIconType="$isOmni ? 'userAccount' : undefined"
        :afterIconType="$isOmni ? 'selectHiliAccount' : 'selectHili'"
        class="passport-function account-setting-function j-profile-btn"
        :class="$platformClass"
        v-touchActive
      >
        <router-link to="/profile" class="link-wrapper">
          <Block
            tagName="p"
            :type="$isOmni ? 'accountFunctionListItem' : 'funtionListItem'"
            class="function-name"
          >
            {{ languages.profile }}
          </Block>
        </router-link>
      </ListItem>
      <ListItem
        type="accountSettingItem"
        rightSpan="0"
        :beforeIconType="$isOmni ? 'userEmail' : undefined"
        :afterIconType="$isOmni ? 'selectHiliAccount' : 'selectHili'"
        class="passport-function account-setting-function j-bind-email-btn"
        :class="$platformClass"
        v-touchActive
      >
        <router-link to="/bindEmail" class="link-wrapper">
          <Block
            tagName="p"
            :type="$isOmni ? 'accountFunctionListItem' : 'funtionListItem'"
            class="function-name"
          >
            {{ languages.bindEmail }}
          </Block>
        </router-link>
      </ListItem>
      <ListItem
        type="accountSettingItem"
        rightSpan="0"
        :beforeIconType="$isOmni ? 'userPwd' : undefined"
        :afterIconType="$isOmni ? 'selectHiliAccount' : 'selectHili'"
        class="passport-function account-setting-function j-change-password-btn"
        :class="$platformClass"
        v-if="!showUpgrade"
        v-touchActive
      >
        <router-link to="/changePassword" class="link-wrapper">
          <Block
            tagName="p"
            :type="$isOmni ? 'accountFunctionListItem' : 'funtionListItem'"
            class="function-name"
          >
            {{ languages.changePassword }}
          </Block>
        </router-link>
      </ListItem>
      <ListItem
        :beforeIconType="$isOmni ? 'userSafe' : undefined"
        :afterIconType="$isOmni ? 'selectHiliAccount' : 'selectHili'"
        type="accountSettingItem"
        rightSpan="0"
        class="passport-function account-setting-function j-security-question-btn"
        :class="$platformClass"
        v-touchActive
      >
        <router-link to="/safeQuession" class="link-wrapper">
          <Block
            tagName="p"
            :type="$isOmni ? 'accountFunctionListItem' : 'funtionListItem'"
            class="function-name"
          >
            {{ languages.securityQuestion }}
          </Block>
        </router-link>
      </ListItem>
    </List>
    <transition name="fade">
      <Dialog v-show="showDialog"></Dialog>
    </transition>
  </Block>
</template>

<script>
import { SHOW_DIALOG, SWICH_ACCOUNT_DIALOG } from '../../store/dialog';
import { LOGOUT } from '../../store/account';
import Header from '../../components/passport/Header';
import commonHeader from '@/resource/components/support/header';
import AccountSettingMixins from '../../mixins/AccountSetting';
import globalConfig from '../../utiles/globalConfig';
import { LOAD_EXTEND_INFO } from '../../store/passport/accountSetting';
import customStyleMixins from '@mixins/customStyle';
export default {
  name: 'AccountSetting',
  data() {
    return {
      isSDK: false
    };
  },
  beforeCreate() {
    this.$store.dispatch(LOAD_EXTEND_INFO);
  },
  mounted() {
    let hasSdkToken = !!globalConfig.getHrefParam('sdkToken');
    let isWeb = +globalConfig.getHrefParam('web') === 1;
    let isH5 = +globalConfig.getHrefParam('h5') === 1;
    this.isSDK = hasSdkToken || (isWeb && isH5);
    // dana渠道处理：
    // 这里就不判断是不是dana小程序环境了globalConfig.isDanaMiniProgram()，因为这个自动跳转具备通用性
    // 如果打开的中户中心带有toAccountUpgrade=1参数，跳转到账号升级页面，账号升级在账号设置里面，先到账号设置
    if (+globalConfig.getHrefParam('toAccountUpgrade') === 1) {
      this.$router.push({ path: '/accountUpgrade' });
    }
  },
  computed: {
    showUpgrade() {
      let notUpgraded =
        /^[a-zA-Z]+\:\d+$/.test(this.$store.state.account.displayName) ||
        this.$store.state.account.displayName == '';
      return notUpgraded;
    },
    userName() {
      return (
        this.$store.state.account.userName ||
        globalConfig.getHrefParam('userName') ||
        ''
      );
    },
    displayName() {
      return this.$store.state.account.displayName;
    },
    userId() {
      return this.$store.state.account.userId;
    },
    logined() {
      if (this.$store.state.account.logined) {
        this.$store.dispatch(LOAD_EXTEND_INFO);
      }
      return this.$store.state.account.logined;
    }
  },
  methods: {
    showSwitchAccountDialog() {
      this.$store.dispatch(SHOW_DIALOG, SWICH_ACCOUNT_DIALOG);
    },
    logout() {
      this.$store.dispatch(LOGOUT, {});
    }
  },
  components: {
    Header,
    commonHeader
  },
  mixins: [AccountSettingMixins, customStyleMixins]
};
</script>

<style lang="scss">
@import '../../assets/scss/base.scss';
@import '../../assets/scss/passport.scss';
@import '../../assets/scss/platform-base.scss';
@import '../../assets/scss/platform-passport.scss';
</style>
